(()=>{
  const items=[
    'GOURMET BRISKET',
    'PREMIUM QUALITY',
    'BOLD FLAVOR',
    'SLOW SMOKED',
    'HIGH PROTEIN',
    'NO ADDED MSG',
    'MADE IN USA'
  ];

  const buildGroup=()=>{
    const group=document.createElement('div');
    group.className='ak-top-marquee__group';
    items.forEach((item,index)=>{
      const text=document.createElement('span');
      text.textContent=item;
      group.appendChild(text);
      const star=document.createElement('b');
      star.textContent='★';
      star.setAttribute('aria-hidden','true');
      group.appendChild(star);
    });
    return group;
  };

  const init=(scope=document)=>{
    const home=scope.querySelector?.('.ak-home')||document.querySelector('.ak-home');
    if(!home)return;
    const hero=home.querySelector('.ak-hero');
    if(!hero||hero.querySelector('.ak-top-marquee'))return;

    const marquee=document.createElement('div');
    marquee.className='ak-top-marquee';
    marquee.setAttribute('aria-hidden','true');

    const track=document.createElement('div');
    track.className='ak-top-marquee__track';
    track.appendChild(buildGroup());
    track.appendChild(buildGroup());
    marquee.appendChild(track);

    hero.classList.add('ak-has-top-marquee');
    hero.insertBefore(marquee,hero.firstChild);
  };

  document.addEventListener('DOMContentLoaded',()=>init(document));
  document.addEventListener('shopify:section:load',event=>init(event.target));
  window.addEventListener('pageshow',()=>init(document));
})();
